import React, { useState } from 'react';
import {
  Typography,
  Grid,
  Box,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Tooltip,
} from '@material-ui/core';
import AvailableServices from '../../data/AvailableServices';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import { apiPatch, apiPost } from '../../api/client';

export default function CreateServiceRequest(props) {
  let history = useHistory();
  const [title, setTitle] = useState(props.title || '');
  const [description, setDescription] = useState(props.description || '');
  const [dueDate, setdueDate] = useState(
    props.serviceabletime ? 'Pick a date' : 'ASAP'
  );
  const [selectedDate, setSelectedDate] = useState(props.serviceabletime || '');
  const [attachments, setAttachments] = useState(props.attachments || []);
  const [selectServiceId, setSelectServiceId] = useState(props.serviceid || '');
  const [deliveryMode, setDeliveryMode] = useState(props.deliverymode || '');

  async function handleUpload(event) {
    const targetFiles = event.target.files;
    for (let f of targetFiles) {
      var stop = false;
      var str = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => resolve(reader.result.replace(/^.*,/, ''));
        reader.onerror = (error) => reject(error);
      });
      attachments.map((element) =>
        element.content === str ? (stop = true) : null
      );
      if (stop) continue;
      {
        setAttachments((prevAttachments) => [
          ...prevAttachments,
          {
            content: str,
            name: f.name,
            type: f.type,
          },
        ]);
      }
    }
  }
  const handleChange = (event) => {
    setSelectedDate();
    setdueDate(event.target.value);
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  function createRequest() {
    const body = {
      title: title,
      description: description,
      serviceId: Number(selectServiceId),
      serviceableTime: selectedDate || null,
      attachments: attachments,
      receivingMethod: deliveryMode || 'In-Person',
      bidType: 'open',
      providerId: props.providerid ? Number(props.providerid) : undefined,
    };
    const call = props.update
      ? apiPatch(`/requests/${props.serviceRequestId}`, {
          title: body.title,
          description: body.description,
        })
      : apiPost('/requests', body);
    call
      .then(() => history.push('/myservicerequests'))
      .catch((err) => {
        alert(`ERR: ${err.message || err}`);
      });
  }

  const servicesList = AvailableServices();

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      direction="column"
      style={{ marginTop: 20 }}
    >
      <Typography
        align="center"
        style={{ color: '#8692a6', fontSize: 30, fontWeight: 600 }}
      >
        {props.update ? 'Update Service Request' : 'Create Service Request'}
      </Typography>
      <Box p={2} mb={1} style={{ width: '500px' }}>
        <Grid container justify="space-between" alignItems="center">
          <Typography>Title of the request</Typography>
          <TextField
            required
            name="Title"
            id="Title"
            type="text"
            variant="outlined"
            margin="dense"
            label={!props.title ? 'Title' : null}
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            style={{ width: '229.6px' }}
          />
        </Grid>
        <Grid container justify="space-between" alignItems="center">
          <Typography>Description</Typography>
          <TextField
            multiline={true}
            style={{ width: '229.6px' }}
            inputProps={{
              style: {
                height: '60px',
              },
            }}
            required
            name="Description"
            id="Description"
            type="text"
            variant="outlined"
            margin="dense"
            label={!props.description ? 'Description' : null}
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </Grid>
        <Grid container justify="space-between" alignItems="center">
          <Typography>Select Service</Typography>
          <TextField
            select
            required
            variant="outlined"
            margin="dense"
            style={{ width: '229.6px' }}
            value={selectServiceId}
            onChange={(e) => setSelectServiceId(e.target.value)}
          >
            {servicesList.map((service) => (
              <MenuItem key={service.serviceid} value={service.serviceid}>
                {service.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid container justify="space-between" alignItems="center">
          <Typography>Delivery mode</Typography>
          <TextField
            select
            required
            variant="outlined"
            margin="dense"
            style={{ width: '229.6px' }}
            value={deliveryMode}
            onChange={(e) => setDeliveryMode(e.target.value)}
          >
            <MenuItem value="In-Person">In-Person</MenuItem>
            <MenuItem value="Virtual">Virtual</MenuItem>
          </TextField>
        </Grid>
        <Grid container justify="space-between" alignItems="center">
          <Typography>Due date</Typography>
          <FormControl component="fieldset">
            <RadioGroup row value={dueDate} onChange={handleChange}>
              <FormControlLabel value="ASAP" control={<Radio />} label="ASAP" />
              <FormControlLabel
                value="Pick a date"
                control={<Radio />}
                label="Pick a date"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        {dueDate === 'Pick a date' && (
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              format="MM/dd/yyyy"
              value={selectedDate}
              onChange={handleDateChange}
            />
            <KeyboardTimePicker margin="normal" value={selectedDate} onChange={handleDateChange} />
          </MuiPickersUtilsProvider>
        )}
        <Grid container justify="space-between" alignItems="center">
          <Typography>Attachments</Typography>
          <input type="file" multiple onChange={handleUpload} />
        </Grid>
        {attachments.map((file, index) => (
          <Grid key={index} container alignItems="center">
            <Typography>{file.name}</Typography>
            <IconButton
              onClick={() =>
                setAttachments(attachments.filter((_, i) => i !== index))
              }
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        ))}
        <Button
          variant="contained"
          style={{ backgroundColor: '#f5802c', color: '#fff', marginTop: 16 }}
          onClick={createRequest}
        >
          {props.update ? 'Update' : 'Create'}
        </Button>
      </Box>
    </Grid>
  );
}
